import React, { useEffect } from "react"
import { Loader } from "../Loader"
import { NumberManagementAdmin } from "./NumberManagementAdmin"
import { NumberManagementIndividual } from "./NumberManagementIndividual"
import { useUserData } from "../../lib/redux/users/user-data-hook"
import { clearCache, SERVICE_CALLS } from "../../extension-helpers"


function NumberRegistration() {
    const { isAdmin } = useUserData()
    useEffect(() => {
        clearCache(SERVICE_CALLS.PARALLEL_SETTINGS)
        clearCache(SERVICE_CALLS.AUTODIALER_INFO)
        clearCache(SERVICE_CALLS.USER_INFO)
    }, []);
    if (isAdmin === null) return <Loader />
    return isAdmin ? <NumberManagementAdmin /> : <NumberManagementIndividual />
}

export { NumberRegistration }
  